import React from 'react';
import PropTypes from 'prop-types';
import useDataSourceContext from '../../DataSource/useDataSourceContext';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { FormattedMessage } from 'react-intl';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Icon from '../../Icon';
import Dropdown from '@afosto/components-react/Dropdown';
import styled from 'styled-components';
import translations from '../translations';

const SelectionBar = styled(AppBar)`
  && {
    background: #000;
    border-top-left-radius: ${props => props.theme.spacing(0.5)}px;
    border-top-right-radius: ${props => props.theme.spacing(0.5)}px;
    color: #fff;
    margin-bottom: ${props => props.theme.spacing(2)}px;

    &.MuiAppBar-positionFixed {
      top: auto;
      bottom: 0;
      width: auto;
      left: ${props => props.theme.spacing()}px;
      right: ${props => props.theme.spacing()}px;
      margin-bottom: 0;
    }
  }
`;

const ClearIcon = styled(Icon)`
  && {
    color: #fff;
  }
`;

const BulkActionsContainer = styled.div`
  color: #fff;
  padding-right: ${props => props.theme.spacing()}px;

  .MuiIconButton-root,
  .MuiButton-root {
    color: #fff;
  }
`;

const SelectionLabel = styled(Typography)`
  && {
    font-weight: bold;
  }
`;

const SelectionReservedSpace = styled.div`
  height: ${props => props.theme.mixins.toolbar.minHeight}px;
`;

const DataListSelectionBar = ({ bulkActions, position }) => {
  const intl = useIntl();
  const dataSource = useDataSourceContext();
  const { data = [], selection: selectionModule = {} } = dataSource;
  const {
    allItemsSelected = false,
    selectedItems,
    setAllItemsSelected,
    setSelectedItems,
    clearSelection,
    allowSelectAll,
  } = selectionModule;

  const handleDeselectAll = () => {
    setAllItemsSelected(false);
    setSelectedItems([]);
  };

  const handleSelectAll = () => {
    setSelectedItems(data.map(item => item.id));
    setAllItemsSelected(true);
  };

  const handleSelectPage = () => {
    setSelectedItems(data.map(item => item.id));
  };

  return (
    <>
      {position === 'fixed' && <SelectionReservedSpace />}
      <SelectionBar position={position} color="default" style={{ zIndex: 1199 }}>
        <Toolbar disableGutters>
          <IconButton onClick={() => clearSelection()}>
            <ClearIcon icon={['fal', 'times']} />
          </IconButton>
          <Box pl={1} pr={1} flexGrow={1}>
            <SelectionLabel variant="body1">
              {allItemsSelected ? (
                <FormattedMessage {...translations.selection.all} />
              ) : (
                selectedItems?.length
              )}
            </SelectionLabel>
          </Box>
          {bulkActions && (
            <BulkActionsContainer>
              {bulkActions.map(action => action.render(dataSource))}
            </BulkActionsContainer>
          )}
          {(allItemsSelected || selectedItems?.length > 0) && (
            <Dropdown
              id="selection-dropdown"
              items={[
                ...(allowSelectAll
                  ? [
                      {
                        text: intl.formatMessage(translations.selection.actions.selectAll),
                        action: handleSelectAll,
                      },
                    ]
                  : []),
                ...(!allItemsSelected
                  ? [
                      {
                        text: intl.formatMessage(translations.selection.actions.selectPage),
                        action: handleSelectPage,
                      },
                    ]
                  : []),
                {
                  text: intl.formatMessage(translations.selection.actions.deselectAll),
                  action: handleDeselectAll,
                  color: 'secondary',
                },
              ]}
            />
          )}
        </Toolbar>
      </SelectionBar>
    </>
  );
};

DataListSelectionBar.propTypes = {
  bulkActions: PropTypes.array,
  position: PropTypes.oneOf(['absolute', 'fixed', 'relative', 'static', 'sticky']),
};

DataListSelectionBar.defaultProps = {
  bulkActions: [],
  position: 'fixed',
};

export default DataListSelectionBar;
